export const UserInformationFields = [
  {
    "key": "first_name",
    "tag": "First Name",
    "$$hashKey": "object:140"
  },
  {
    "key": "last_name",
    "tag": "Last Name",
    "$$hashKey": "object:141"
  },
  {
    "key": "email",
    "tag": "Email",
    "$$hashKey": "object:142"
  },
  {
    "key": "grade",
    "tag": "Grade",
    "$$hashKey": "object:143"
  },
  {
    "key": "rate",
    "tag": "Rate",
    "$$hashKey": "object:144"
  },
  {
    "key": "phone",
    "tag": "Telephone",
    "$$hashKey": "object:145"
  },
  {
    "key": "street",
    "tag": "Street Name",
    "$$hashKey": "object:146"
  },
  {
    "key": "employee_address_street_name",
    "tag": "Street Name (From I9)",
    "$$hashKey": "object:147"
  },
  {
    "key": "house",
    "tag": "Street Number",
    "$$hashKey": "object:148"
  },
  {
    "key": "employee_address_street_number",
    "tag": "Street Number (From I9)",
    "$$hashKey": "object:149"
  },
  {
    "key": "employee_middle_initial",
    "tag": "Middle Name",
    "$$hashKey": "object:150"
  },
  {
    "key": "employee_number",
    "tag": "ID number",
    "$$hashKey": "object:151"
  },
  {
    "key": "employee_additional_number",
    "tag": "ADDL employee number / Name",
    "$$hashKey": "object:152"
  },
  {
    "key": "employee_apt_number",
    "tag": "Apt Number(From I9)",
    "$$hashKey": "object:153"
  },
  {
    "key": "employee_city_or_town",
    "tag": "City (From I9)",
    "$$hashKey": "object:154"
  },
  {
    "key": "city",
    "tag": "City",
    "$$hashKey": "object:155"
  },
  {
    "key": "employee_state",
    "tag": "State  (From I9)",
    "$$hashKey": "object:156"
  },
  {
    "key": "employee_zip_code",
    "tag": "Zip Code  (From I9)",
    "$$hashKey": "object:157"
  },
  {
    "key": "zip",
    "tag": "Zip Code",
    "$$hashKey": "object:158"
  },
  {
    "key": "state",
    "tag": "State",
    "$$hashKey": "object:159"
  },
  {
    "key": "apartment",
    "tag": "Apartment",
    "$$hashKey": "object:160"
  },
  {
    "key": "branch_id",
    "tag": "Branch",
    "$$hashKey": "object:161"
  },
  {
    "key": "user_position_id",
    "tag": "Position",
    "$$hashKey": "object:162"
  },
  {
    "key": "birth_date",
    "tag": "Birth Date",
    "$$hashKey": "object:163"
  }
]
